export default __webpack_public_path__ + "static/media/gOHM.eb673cda.png";